import React, {Component, createRef, useRef } from 'react';
import {connect} from "react-redux";

import { MentionsInput, Mention } from '../../lib/mention';
import {Picker} from 'emoji-mart';
import {sendMessage,pickFromQueue} from "../../actions/actions"
import 'emoji-mart/css/emoji-mart.css';
import TimeAgo from "react-timeago";
import { useNavigate } from "react-router-dom";


@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})

class ChatFooter extends Component {


    constructor(props) {
        super(props);
        this.messageBoxRef=createRef();
        this.state = {
            [this.props.id]: {
                disabledSendButton: true,
                message_text: "",
                buttonActiveClass: '',
                isActiveEmoji: false,
                typing:false,
                timeout :undefined,
                selected_mention:"",
				preview_display: "none"
            },
        };


        this.currentID = this.props.id;
        this._handleKeyDown = this._handleKeyDown.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.setEmoji = this.setEmoji.bind(this);
        this.pickFromQueue = this.pickFromQueue.bind(this);
        this.renderSuggestion = this.renderSuggestion.bind(this);
        this.openManuelMention = this.openManuelMention.bind(this);
		this.pickFromQueueFunc=this.pickFromQueueFunc.bind(this);
		
		this.openImageUpload = this.openImageUpload.bind(this);
		this.setUploadImage = this.setUploadImage.bind(this);
		this.handlePaste = this.handlePaste.bind(this);
		this.removeImage = this.removeImage.bind(this);


		this.convertDate=this.convertDate.bind(this);
    }
	
	convertDate(UNIX_timestamp){
        var a = new Date(UNIX_timestamp * 1000);
  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var year = a.getFullYear();
  var month = (a.getMonth() < 10 ? '0':'')+a.getMonth();
  var date = (a.getDate() < 10 ? '0':'')+a.getDate();
  var hour = (a.getHours() < 10 ? '0':'')+a.getHours();
  var min = (a.getMinutes() < 10 ? '0':'')+a.getMinutes();
  var sec = (a.getSeconds() < 10 ? '0':'')+a.getSeconds();
  var time = date + '.' + month + '.' + year + ' ' + hour + ':' + min;
  return time;
    }
	
	removeImage(e) {
		this.imageUploadInput.value = "";
		this.setState({
            [this.props.id]: {
                disabledSendButton: this.state[this.props.id].disabledSendButton,
                message_text: this.state[this.props.id].message_text,
                buttonActiveClass: this.state[this.props.id].buttonActiveClass,
                isActiveEmoji: this.state[this.props.id].isActiveEmoji,
                typing:this.state[this.props.id].typing,
                timeout :this.state[this.props.id].timeout,
                selected_mention:this.state[this.props.id].selected_mention,
				preview_display: "none"
            }
        });
    }

	openImageUpload(e) {
        this.imageUploadInput.click();
    }
	
	setUploadImage(e) {
        var item = this.imageUploadInput.files[0];
		
		if(item.name.substring(item.name.lastIndexOf(".")+1) == "pdf"){
			this.imagePreview.src = "https://service.itemci.com/Public/images/classic/pdf.jpeg";
		}else{
			this.imagePreview.src = URL.createObjectURL(item);
		}
	  
	  		this.setState({
            [this.props.id]: {
                disabledSendButton: this.state[this.props.id].disabledSendButton,
                message_text: this.state[this.props.id].message_text,
                buttonActiveClass: this.state[this.props.id].buttonActiveClass,
                isActiveEmoji: this.state[this.props.id].isActiveEmoji,
                typing:this.state[this.props.id].typing,
                timeout :this.state[this.props.id].timeout,
                selected_mention:this.state[this.props.id].selected_mention,
				preview_display: "block"
            }
        });
    }
	
	handlePaste = (e) => {
    if (e.clipboardData.files.length) {
      const item = e.clipboardData.files[0];
	  
		if(item.name.substring(item.name.lastIndexOf(".")+1) == "pdf"){
			this.imagePreview.src = "https://service.itemci.com/Public/images/classic/pdf.jpeg";
		}else{
			this.imagePreview.src = URL.createObjectURL(item);
		}
	  
	  		this.setState({
            [this.props.id]: {
                disabledSendButton: this.state[this.props.id].disabledSendButton,
                message_text: this.state[this.props.id].message_text,
                buttonActiveClass: this.state[this.props.id].buttonActiveClass,
                isActiveEmoji: this.state[this.props.id].isActiveEmoji,
                typing:this.state[this.props.id].typing,
                timeout :this.state[this.props.id].timeout,
                selected_mention:this.state[this.props.id].selected_mention,
				preview_display: "block"
            }
        });
	  let file = new File([item], "file name",{type:"image/jpeg", lastModified:new Date().getTime()}, 'utf-8');
	  let container = new DataTransfer(); 
      container.items.add(file);
		
	  this.imageUploadInput.files = container.files;
    }
  };



    openManuelMention(){
        this.setState({
            [this.props.id]: {
                "message_text": this.state[this.props.id].message_text+(this.state[this.props.id].message_text.length<1 ? "#" : " #"),
				preview_display: this.state[this.props.id].preview_display
            }
        });
        this.messageBoxRef?.current?.focus();
    }

    renderSuggestion(suggestion, search, highlightedDisplay, index){

        return (
            <div className="suggestionFlex">
                <div className="suggestionFlexItem">
                    <span className="key">{suggestion.key}</span>
                </div>
                <div className="suggestionFlexItem">
                    <span className="message">
                         {suggestion.message}
                    </span>

                </div>

            </div>
        );
    }


    pickFromQueue(e,id){

        this.props.dispatch(pickFromQueue(id));
        e.preventDefault();
    }
    setEmoji(emoji) {
        this.messageBoxRef.current.focus();
        this.setState({
            [this.props.id]: {
                buttonActiveClass: ' sendMessageActive',
                disabledSendButton: false,
                message_text: this.state[this.props.id].message_text + " " + emoji,
				preview_display: this.state[this.props.id].preview_display
            }
        });
    }


    typingTimeoutFunction=()=>{
        this.setState({
            [this.props.id]: {
                typing: false,
                disabledSendButton:this.state[this.props.id].disabledSendButton,
                message_text:this.state[this.props.id].message_text,
                buttonActiveClass:this.state[this.props.id].buttonActiveClass,
                isActiveEmoji:this.state[this.props.id].isActiveEmoji,
                timeout:this.state[this.props.id].timeout,
				preview_display: this.state[this.props.id].preview_display
            }
        });

        if(typeof this.props.chat.userData!=="undefined"){
            if(typeof this.props.chat.userData.id!=="undefined"){
                NODECONNECT.socket.emit("noLongerTypingMessage",{"k":this.props.chat.userData.id});
            }
        }
    }
    handleChange(event,newValue,newPlainTextValue) {
        if (event.target.value.trim().length > 0) {


          //  event.target.value=newPlainTextValue;

            if(this.state[this.props.id].typing == false) {
                if(typeof this.props.chat.userData!=="undefined"){
                    if(typeof this.props.chat.userData.id!=="undefined"){
                        if(this.props.chat.supervised!==1){
                            NODECONNECT.socket.emit("typingMessage",{"k":this.props.chat.userData.id});
                        }

                    }
                }

                this.setState({
                    [this.props.id]: {
                        typing: true,
                        disabledSendButton:this.state[this.props.id].disabledSendButton,
                        message_text:this.state[this.props.id].message_text,
                        buttonActiveClass:this.state[this.props.id].buttonActiveClass,
                        isActiveEmoji:this.state[this.props.id].isActiveEmoji,
                        timeout:this.state[this.props.id].timeout,
						preview_display: this.state[this.props.id].preview_display
                    }
                });
                if(this.props.chat.supervised!==1) {
                    this.state[this.props.id].timeout = setTimeout(this.typingTimeoutFunction, 5000);
                }
            } else {
                if(this.props.chat.supervised!==1) {
                    clearTimeout(this.state[this.props.id].timeout);
                }
                this.setState({
                    [this.props.id]: {
                        typing: this.state[this.props.id].typing,
                        disabledSendButton:this.state[this.props.id].disabledSendButton,
                        message_text:this.state[this.props.id].message_text,
                        buttonActiveClass:this.state[this.props.id].buttonActiveClass,
                        isActiveEmoji:this.state[this.props.id].isActiveEmoji,
                        timeout: this.props.chat.supervised!==1 ? setTimeout(this.typingTimeoutFunction, 5000) : undefined,
						preview_display: this.state[this.props.id].preview_display
                    }
                });

            }
            this.setState({
                [this.props.id]: {
                    disabledSendButton: false,
                    message_text: event.target.value,
                    buttonActiveClass: ' sendMessageActive',
					preview_display: this.state[this.props.id].preview_display
                }
            });

        } else {
            this.setState({[this.props.id]: {disabledSendButton: true, message_text: "", buttonActiveClass: '', preview_display: this.state[this.props.id].preview_display}});

        }
    }
	
	pickFromQueueFunc(){
		var getChats=this.props.chatprop.activeChats.filter(chat=>chat.status=='P' & chat.supervised!=1);
		var getFirstChat = Object.keys(getChats).sort((a, b) => a.pending_time > b.pending_time ? 1:-1);
		var getChat = getChats[getFirstChat[0]];
		var id = getChat.id;
		//console.log(id);
        this.props.dispatch(pickFromQueue(id));
        this.props.navigate("/chat/"+id);
    }

    _handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
			var file = "";
			if(typeof this.imageUploadInput.files[0]  !== "undefined") {
			file = this.imageUploadInput.files[0];
			}
			
             this.props.dispatch(sendMessage({
                 chat_id:this.props.id,
                 message:this.state[this.props.id].message_text,
				 file: file
             }));
            this.setState({
                [this.props.id]: {
                    disabledSendButton: true,
                    message_text: "",
                    buttonActiveClass: '',
					preview_display: "none"
                }
            });
			this.imageUploadInput.value = "";
            e.preventDefault();
        }else if(e.key === 'j' && e.ctrlKey && e.altKey){
			e.preventDefault();
			this.pickFromQueueFunc();
		}
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.id != prevProps.id) {
            if (typeof this.state[this.props.id] === "undefined") {
                this.setState({[this.props.id]: {disabledSendButton: true, message_text: "", buttonActiveClass: '', preview_display: "none"}});

            }
			this.messageBoxRef?.current?.focus();
            this.readMessage();

        }
    }

    readMessage(){
        var messages=this.props.chat.messages;
        var unreadMessage=messages.filter(message=>message.read_agent_state==2 && (message.receiver==2 || message.receiver==3) && message.sender==1).length;
        if(unreadMessage>0){

            NODECONNECT.socket.emit("adminReadMessage",{"i":this.props.id});
        }

    }


    componentDidMount() {
        this.readMessage();

    }


    _openPicker = e => {
        e.preventDefault();
        if (this.ignoreClick) {
            this.ignoreClick = false;
            return;
        }

        this.setState({
            [this.props.id]: {
                isActiveEmoji: !this.state[this.props.id].isActiveEmoji,
                disabledSendButton: this.state[this.props.id].disabledSendButton,
                message_text: this.state[this.props.id].message_text,
                buttonActiveClass: this.state[this.props.id].buttonActiveClass,
				preview_display: this.state[this.props.id].preview_display
            }
        });

    };

    render() {
        const {t} = this.props;



        if (typeof this.state[this.props.id] === "undefined") {
            return "";
        }


        var $canned_responses=[];

        var $i=0;
        Object.keys(this.props.chatprop.canned_response).forEach((key)=>{
            $canned_responses.push({
                "id":this.props.chatprop.canned_response[key].message+$i,
                "display":"#" + this.props.chatprop.canned_response[key].shortcut,
                "key":"#" + this.props.chatprop.canned_response[key].shortcut,
                "message":this.props.chatprop.canned_response[key].message
            });
            $i++;
        })


        if (this.props.chat.status == "A") {
            if (this.props.chat.user_closed === 0) {
                if(this.props.chat.user_status!=1){
                    this.props.chat.typing = 0;
                }
                    return (
                        <div className="chat-footer">

                            <div className="send-message-container">
                                <div style={{"height": "30px"}}>
                                {typeof this.props.chat.typing !== "undefined" &&
                                <>
                                    {this.props.chat.typing === 1 &&
                                    <>
                                                  <span className="animate-typing-col" style={{"marginRight": "5px"}}>
                                                       <span className="dot"></span>
                                                       <span className="dot"></span>
                                                       <span className="dot"></span>
                                                   </span>
                                        {this.props.chat.typingMessage}
                                    </>
                                    }
                                </>
                                }
                            </div>
                                <div className={"message-container "+ (this.props.chat.supervised===1 ? "message-supervised" : "")}>
									<div class="previewImageContent" ref={div => this.imagePreviewContent = div} style={{display: this.state[this.props.id].preview_display, height: "250px", width: "100%", overflow: "hidden", "text-align": "center"}}>
									<button
                                                        title="Remove Image"
                                                        onClick={this.removeImage.bind(this)}
                                                        className="settings-button"
														style={{position: "absolute", top: "10px", right: "10px", width: "25px", height: "25px", "border-radius": "25px", color: "#fff", "background-color": "var(--red)", padding: "0px", border: "none"}}
														>
                                                       <i className='bx bx-x'></i>
                                                    </button>
									<img class="previewImage" ref={img => this.imagePreview = img} style={{height: "100%", width: "auto"}} />
									</div>
                                    <div className="textarea-container">
                                        <MentionsInput
											onPaste={this.handlePaste}
                                            allowSpaceInQuery={true}
                                            inputRef={ this.messageBoxRef}
                                            className={"messageBox"}
                                            value={this.state[this.props.id].message_text}
                                            onChange={this.handleChange}
                                            onKeyDown={this._handleKeyDown}
                                            placeholder={this.props.chat.supervised===1 ? "Private messages will be visible to agents only…" : "Type a message..."}
                                            aria-label="message box textarea"
                                            translate="no" style={{"max-height": "140px"}}
                                            autoFocus
                                        >
                                            <Mention
                                                trigger="#"
                                                appendSpaceOnAdd
                                                data={$canned_responses}
                                                renderSuggestion={this.renderSuggestion}
                                            />

                                        </MentionsInput>
                                    </div>
                                    <div className="toolbar-container">
                                        <div className="toolbar-wrapper">
                                            <div className="wrapper-settings">
                                                <div className="emoji-picker-wrapper">
                                                    {this.state[this.props.id].isActiveEmoji &&
                                                    <div className="emoji-picker">
                                                        <Picker showPreview={false} set={'facebook'}
                                                                showSkinTones={false}
                                                                onSelect={emoji => this.setEmoji(emoji.native)}/>
                                                    </div>
                                                    }
                                                    <button
                                                        title="Emoji Picker"
                                                        className="settings-button" onClick={this._openPicker}>
                                                        <i className='bx bx-smile'></i>
                                                    </button>

                                                </div>

                                                <div className="canned-responses">
                                                    <button
                                                        title="Canned Responses"
                                                        onClick={this.openManuelMention}
                                                        className="settings-button">
                                                       #
                                                    </button>
                                                </div>
												
												<div className="canned-responses">
												<input className="image-file-upload"
                                                           ref={input => this.imageUploadInput = input}
                                                           style={{display: "none"}}
                                                           type="file"
                                                           name="image_file"
                                                           onChange={e => this.setUploadImage(e)}
                                                           accept="image/*, application/pdf"/>
                                                    <button
                                                        title="Image Upload"
                                                        onClick={this.openImageUpload.bind(this)}
                                                        className="settings-button">
                                                       <i className='bx bx-upload'></i>
                                                    </button>
                                                </div>

                                            </div>
                                            <div className="wrapper-right-button">
                                                <button
                                                    className={"chat-button chat-button-default sendMessage sendMessageDisabled " + this.state[this.props.id].buttonActiveClass}
                                                    disabled={this.state[this.props.id].disabledSendButton}
                                                >Send
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )


            } else {
                return (
                    <div className='pending_message_container'><p>chat closed</p></div>
                )
            }
        } else if (this.props.chat.status == "P") {

            return (
                <div className="pending_message_container">
                    <p>{this.props.chat.user_name} is waiting in queue for <TimeAgo date={new Date(this.props.chat.pending_time*1000)} />
                    </p>
                    <button
                        className="chat-button chat-button-default pickFromQueue"
                        onClick={e=>this.pickFromQueue(e,this.props.chat.id)}
                    >Pick from queue
                    </button>
                </div>
            );

        } else {
            return (<div className='pending_message_container'><p>chat closed & archived</p><span>{this.convertDate(this.props.chat.closed_time)}</span></div>);
        }


    }
}

function WithNavigate(props) {
    let navigate = useNavigate();
    return <ChatFooter {...props} navigate={navigate} />
}

export default WithNavigate

//export default ChatFooter;




